/**
 * GoDigit Light KYC: skip our OVD/KYC screens when premium is strictly below ₹5000.
 * @param {object} plan - selected quote / selected_plan_data
 * @returns {boolean}
 */
export function shouldSkipGodigitKycOvd(plan) {
  const insurer = plan?.insuranceAndProducts?.insuranceCompanyCode;
  const premium = Number(
    plan?.productDetails?.totalPremiumDetails?.[0]?.totalPremiumValueBeforeTax
  );
  return insurer === 'GODIGIT' && Number.isFinite(premium) && premium < 5000;
}
